import React from "react";
import { Controller } from "react-hook-form";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import Tooltip from "@mui/material/Tooltip";
// import InfoIcon from "@mui/icons-material/Info";
import InputLabel from "@mui/material/InputLabel";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import InfoIcon from "../GFSRulesIcon/InfoIcon";
import Button from "@mui/material/Button";

export const SelectOne = ({
  control,
  name,
  id,
  label,
  optionList,
  tooltip,
  rules = {},
  ...props
}) => {
  const renderLabelWithTooltip = (
    <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
      {label}
      {tooltip && (
        <Tooltip
          title={tooltip}
          arrow
          placement="top"
          componentsProps={{
            tooltip: {
              sx: {
                maxWidth: "none",
                width: 250,
                fontSize: "11px",
                padding: "12px 10px",
                whiteSpace: "normal",
              },
            },
          }}
        >
          <Button sx={{ padding: "0px", minWidth: "0px" }}>
            <InfoIcon />
          </Button>
        </Tooltip>
      )}
    </span>
  );

  return (
    <FormControl fullWidth variant="outlined" sx={{ marginBottom: 2 }}>
      <InputLabel
        id={`${id}-label`}
        shrink
        sx={{
          fontSize: "14px",
          fontWeight: "500",
          color: "#8E8E8E",
          backgroundColor: "#fff",
          "&.Mui-focused": {
            color: "#4B7BCF",
          },
        }}
      >
        {renderLabelWithTooltip}
      </InputLabel>

      <Controller
        name={name}
        control={control}
        defaultValue=""
        rules={rules}
        render={({ field }) => (
          <Select
            {...props}
            labelId={`${id}-label`}
            id={id}
            {...field}
            input={<OutlinedInput label={label} />}
            displayEmpty
            sx={{
              height: "50px",
              fontSize: "14px",
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#E2E0E0",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#2d65c7",
              },
            }}
          >
            <MenuItem
              value=""
              sx={{
                fontSize: "14px",
              }}
            >
              Select {label}
            </MenuItem>
            {optionList.map((item) => (
              <MenuItem
                key={item.value}
                value={item.value}
                sx={{
                  fontSize: "14px",
                }}
              >
                {item.label}
              </MenuItem>
            ))}
          </Select>
        )}
      />
    </FormControl>
  );
};

